// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"140":"1e78b08f","239":"86bc6427","863":"reg-login"}[chunkId] || chunkId) + "." + {"67":"dea9dc31f888d9c9","140":"6053c7e5046f3ffa","239":"25d654dcd9ebc17e","553":"dea20a29ca447610","863":"c30af30a0a57c309"}[chunkId] + ".js";
};